/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const PieChartIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path d="M9.655 3.434c.41-.075.77.252.77.668v8.77c0 .389.314.704.702.704H19.9c.416 0 .742.36.667.768C19.765 18.7 15.948 22 11.36 22A9.36 9.36 0 0 1 9.655 3.434m3.403-1.426a10.77 10.77 0 0 1 8.934 8.935c.064.407-.261.76-.673.76H13a.703.703 0 0 1-.703-.703V2.682c0-.412.355-.738.762-.674" /></svg>;
};
export default PieChartIcon;